import { useTranslation } from '@sm360/hooks'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'

const TermsTableItem = ({ termItem, selectedPayment, paymentFrequency, onClick }) => {
    const { t } = useTranslation()
    const { apr, payment, term, totalPayment } = termItem
    const { payment: paymentSelected, paymentTaxes, taxesDetail } = selectedPayment

    const isSelected = payment === paymentSelected

    const classNames = clsx('pc-termsTableItem', isSelected && '-selected')

    const handleClick = async () => onClick(term)

    return (
        <div className={classNames} onClick={handleClick} onKeyDown={handleClick} role='button' tabIndex='0'>
            <div className='pc-termsTableItem__term'>
                <span>{term}</span>
                <span>{t('pc.months')}</span>
            </div>
            <div className='pc-termsTableItem__rate-payment'>
                <div className='pc-termsTableItem__details'>
                    <div className='pc-termsTableItem__rate'>{apr}%</div>
                    <div className='pc-termsTableItem__payment'>
                        {payment} $ {t(`pc.byPaymentFrequency.${paymentFrequency}`)}
                    </div>
                </div>
                <div className='pc-termsTableItem__disclaimer'>
                    {t('pc.termPayment.priceDisclaimer', { payment, paymentTaxes, taxesDetail, totalPayment })}
                </div>
            </div>
        </div>
    )
}

TermsTableItem.propTypes = {
    termItem: PropTypes.object,
    selectedPayment: PropTypes.object,
    onClick: PropTypes.func,
    paymentFrequency: PropTypes.number,
}

TermsTableItem.defaultProps = {
    termItem: {},
    selectedPayment: {},
    onClick: () => {},
}

export default TermsTableItem
